module.exports = __webpack_public_path__ + "static/media/089.9196a366.jpg";